export default {"src":"/_next/static/media/desk.9eda5037.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};